import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { SidebarMenuItemContainer } from '../SidebarMenuItem/styled';
import { ICON_CONTAINER_WIDTH, LIST_GAP, LOGOTYPE_PADDING } from '../config';
export const SidebarMenuCollapsibleItemContainer = styled(SidebarMenuItemContainer) `
  min-height: ${ICON_CONTAINER_WIDTH};
  margin-left: ${ICON_CONTAINER_WIDTH};
  padding: 0 ${LOGOTYPE_PADDING};

  ${(props) => props.$isMenuChild &&
    `
    width: calc(100% - ${themeGet('spacing.sm')} * 2);
    padding-right: ${pxToRem(32)};
    margin: ${themeGet('spacing.sm')};
  `}

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: calc(100% + ${ICON_CONTAINER_WIDTH} / 2);
    width: ${pxToRem(2)};
    height: calc(100% + ${LIST_GAP});
    background-color: ${themeGet('colors.gray.100')};
  }

  &:first-of-type:not(:last-of-type):after {
    height: 75%;
    top: 50%;
  }

  &:last-of-type:not(:first-of-type):after {
    height: 75%;
    top: -25%;
  }

  &:first-of-type:last-of-type:after {
    height: 20%;
    top: 40%;
  }
`;
